import { render, staticRenderFns } from "./index.vue?vue&type=template&id=34644c65"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSeal: require('/opt/build/repo/components/Elements/Seal.vue').default,ElementsLink: require('/opt/build/repo/components/Elements/Link.vue').default,ElementsSealBlur: require('/opt/build/repo/components/Elements/SealBlur.vue').default,ElementsImage: require('/opt/build/repo/components/Elements/Image.vue').default,ElementsRichText: require('/opt/build/repo/components/Elements/RichText.vue').default})
